import { activityFeedStore } from "client/Features/ActivityFeed/store";
import createVanilla, { StoreApi } from "zustand/vanilla";
import create, { UseStore } from "zustand";
import { newGuid } from "./guid";
import { Guid } from "client_legacy/ndaw/guid";
import { isNotNil } from "client/Misc/utils";
import { shallowComparison } from "client/Misc/compareUtils";

export function init(): void {
	let title: string = "";
	let amount: number = 0;

	activityFeedStore.subscribe<number | undefined>(
		amountOfUnreadNotifications => {
			if (isNotNil(amountOfUnreadNotifications)) {
				amount = amountOfUnreadNotifications;
				updateTitleWithUnreadActivities(amountOfUnreadNotifications, title);
			}
		},
		state => state.amountOfUnreadNotifications,
		shallowComparison
	);

	browserTitleStore.subscribe<string>(
		newTitle => {
			title = newTitle;
			updateTitleWithUnreadActivities(amount, title);
		},
		state => state.title,
		shallowComparison
	);

	browserTitleStore.getState()
		.setTitle(document.title);
}

function updateTitleWithUnreadActivities(amount: number, title: string): void {
	if (amount <= 0) {
		document.title = title;
	} else {
		document.title = `(${amount > 99 ? "99+" : amount}) ${title}`;
	}
}

export type BrowserTitleStoreData = {
	title: string;
	setTitle(title: string): Guid;
	clearTitle(token: Guid): void;
};

export const browserTitleStore: StoreApi<BrowserTitleStoreData> = createVanilla<BrowserTitleStoreData>(
	(set) => {
		const titleStack: StackItem[] = [];

		const assignTopItemOfTheStackAsTitle = (): void => {
			if (titleStack.length === 0) {
				set({ title: "" });
			} else {
				const topItem: StackItem = titleStack[titleStack.length - 1];
				set({ title: topItem.title });
			}
		};

		return {
			title: "",
			setTitle(title: string): Guid {
				const newTitleItem: StackItem = {
					title,
					token: newGuid()
				};

				titleStack.push(newTitleItem);

				assignTopItemOfTheStackAsTitle();

				return newTitleItem.token;
			},
			clearTitle(token: Guid): void {
				const indexOfItemToRemove: number = titleStack.findIndex(i => i.token === token);

				if (indexOfItemToRemove !== -1) {
					titleStack.splice(indexOfItemToRemove, 1);
				}

				assignTopItemOfTheStackAsTitle();
			}
		};
	}
);

export const useBrowserTitleStore: UseStore<BrowserTitleStoreData> = create(browserTitleStore);

type StackItem = {
	title: string;
	token: Guid;
};